// extracted by mini-css-extract-plugin
export default {"cnt":"UserAchievements_cnt__ZhHHh","slider":"UserAchievements_slider__fppvr","sliderItem":"UserAchievements_sliderItem__p4SHS","ready":"UserAchievements_ready__dJx-X"};